import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M240-80v-170q-36-16-65.5-43T124-355.5 91.5-433 80-520q0-158 112-259t288-101 288 101 112 259q0 45-11.5 87T836-355.5 785.5-293 720-250v170zm60-60h70v-100h60v100h100v-100h60v100h70v-147q37-11 66.5-33t50.5-52.5 32-68.019 11-79.327q0-133.997-94-217.076T480.043-820t-246 83.088T140-519.812Q140-478 151-440.5t32 68 50.5 52.5 66.5 33zm120-220h120l-60-120zm-79.911-100Q369-460 389.5-480.589t20.5-49.5-20.589-49.411-49.5-20.5-49.411 20.589-20.5 49.5 20.589 49.411 49.5 20.5m280 0Q649-460 669.5-480.589t20.5-49.5-20.589-49.411q-20.588-20.5-49.5-20.5T570.5-579.411q-20.5 20.588-20.5 49.5t20.589 49.411q20.588 20.5 49.5 20.5M480-140" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }